import script from "./LiveSessionComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveSessionComponent.vue?vue&type=script&setup=true&lang=js"

import "./LiveSessionComponent.vue?vue&type=style&index=0&id=4eaf21da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4eaf21da"]])

export default __exports__